"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SelectStyle = exports.ErrorText = exports.HelperText = exports.LabelStyle = exports.StyleBase = void 0;

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var colors = _interopRequireWildcard(require("../style/colors"));

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj["default"] = obj;
    return newObj;
  }
}

var StyleBase = _styledComponents["default"].div.withConfig({
  displayName: "StyleBase",
  componentId: "q0093m-0"
})(["font-family:'Roboto',sans-serif;line-height:24px;"]);

exports.StyleBase = StyleBase;

var LabelStyle = _styledComponents["default"].label.withConfig({
  displayName: "LabelStyle",
  componentId: "q0093m-1"
})(["margin-bottom:8px;font-size:12px;display:block;"]);

exports.LabelStyle = LabelStyle;

var HelperText = _styledComponents["default"].div.withConfig({
  displayName: "HelperText",
  componentId: "q0093m-2"
})(["margin:-8px 0 8px;font-size:12px;color:", ";"], colors.textColor);

exports.HelperText = HelperText;

var ErrorText = _styledComponents["default"].div.withConfig({
  displayName: "ErrorText",
  componentId: "q0093m-3"
})(["margin:8px 0 0 8px;font-size:12px;color:", ";line-height:14px;"], colors.red);

exports.ErrorText = ErrorText;

var SelectStyle = _styledComponents["default"].select.withConfig({
  displayName: "SelectStyle",
  componentId: "q0093m-4"
})(["border:1px solid ", ";padding:8px;background-color:#fff;background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 5.9 5.9'%3E%3Cpath fill='%23212121' d='M3 3.3l2.2-2.2.7.8L3 4.8 0 1.9l.8-.8z'/%3E%3C/svg%3E\");background-position:right 15px center;background-repeat:no-repeat;background-size:9px;appearance:none;height:40px;border-radius:4px;width:100%;font-size:14px;color:", ";&:focus{border-color:", ";outline:0;}&[disabled]{background-color:", ";color:", ";cursor:not-allowed;}", ""], colors.borderColor, colors.titleColor, colors.primary, colors.backgroundColor, colors.borderColor, function (props) {
  return props.hasError && (0, _styledComponents.css)(["border-color:", ";"], colors.red);
});

exports.SelectStyle = SelectStyle;